'use client';

import * as React from 'react';

import { ThemeProvider as NextThemesProvider, useTheme } from 'next-themes';
import { type ThemeProviderProps } from 'next-themes/dist/types';

import { useAuth } from '@/contexts/AuthContext';
import { useProfileMetadata } from '@/hooks/useProfile';

function AccountThemeSync({ accountTheme }: { accountTheme: unknown }) {
  const { setTheme } = useTheme();
  const [sessionTheme] = React.useState(accountTheme);

  React.useEffect(() => {
    if (
      sessionTheme === 'light' ||
      sessionTheme === 'dark' ||
      sessionTheme === 'system'
    ) {
      setTheme(sessionTheme);
    }
  }, [sessionTheme, setTheme]);

  return null;
}

export function ThemeProvider({ children, ...props }: ThemeProviderProps) {
  const { user } = useAuth();
  const { metadata } = useProfileMetadata();

  return (
    <NextThemesProvider {...props}>
      {metadata && (
        <AccountThemeSync key={user?.id} accountTheme={metadata.theme} />
      )}
      {children}
    </NextThemesProvider>
  );
}
